module.exports = __webpack_public_path__ + "static/media/blank 1.d5c965e0.svg";